// removed by extract-text-webpack-plugin
module.exports = {"container":"_-5nT0fbC9CkfbFo_1N3K-","icon":"_2POvqTgBQcKr1PjpS0S7FW","title":"_2pXRJb7b1O2XkVPo79Uauw","Title":"_1U8MXCddikZPJVWjBJgj93"};


//////////////////
// WEBPACK FOOTER
// ./src/App/Pages/Documents/Document/UpdateInformation/styles.css
// module id = 2852
// module chunks = 0